import { render, staticRenderFns } from "./H5Image.vue?vue&type=template&id=5046df00&lang=pug&"
import script from "./H5Image.vue?vue&type=script&lang=ts&"
export * from "./H5Image.vue?vue&type=script&lang=ts&"
import style0 from "./H5Image.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports